import React, {useEffect, useState} from 'react';
import './alert.css';
import Translate from "localization/Translate";
import {useDispatch, useSelector} from "react-redux";
import {removeAlert} from "../redux/actions";

export default () => {
    const alert = useSelector(state => state.rootReducer.alert);
    const dispatch = useDispatch();
    const [alertTimeout, setAlertTimeout] = useState(0);

    useEffect(() => {
        if(alertTimeout !== 0){
            window.clearTimeout(alertTimeout);
            setAlertTimeout(0);
        }
        if(alert.autoClose){
            setAlertTimeout(window.setTimeout(() => {
                dispatch(removeAlert());
            }, 3000));
        }
        return () => {};
    }, [alert]);

    if(alert === false) {
        return false;
    }

    let className = "alert " + (alert.type === 'info' ? 'infoAlert' : 'errorAlert');
    let closeButton;

    if(!alert.autoClose){
        closeButton =
            <span
                onClick={() => {
                    dispatch(removeAlert());
                }}
                style={{
                    position: 'absolute',
                    right: '1.07rem',
                    fontSize: '1.79rem',
                    top: '0.5rem'
                }}
            >X</span>;
    }

    return (
        <div className={className}><Translate id={alert.message}/>{closeButton}</div>
    );
}